import {EScene} from '@/types/scene.types'
import {useTracking} from '@repo/shared/Tracking/Tracking.hooks'
import {useAtomValue} from 'jotai'
import {useEffect} from 'react'
import {useTransitionState} from 'react-transition-state'
import {sceneState} from '../Store/atoms'
import PreLobby from './PreLobby'

export const PreLobbyScreen = () => {
  const scene = useAtomValue(sceneState)
  const {trackScreenEnter} = useTracking()

  const [state, toggle] = useTransitionState({
    timeout: {
      enter: 0,
      exit: 500, // <-- time allowed for the exit animation
    },
  })

  /**
   * If the scene is pre-lobby, toggle the transition
   */
  useEffect(() => {
    if (scene === EScene.PRE_LOBBY) {
      toggle(true)

      trackScreenEnter({
        screenIdentifier: 'pre-lobby',
        abstractPath: '/pre-lobby',
      })
    } else {
      toggle(false)
    }
  }, [scene])

  /**
   * If the status is exited, don't render anything
   */
  if (state.status === 'exited') {
    return null
  }

  return <PreLobby transitionStatus={state.status} />
}
